import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { PebbleMark } from "../components/Logo";

export default function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("This sign-in link is missing its token. Request a fresh one.");
      return;
    }
    api.get(`/auth/verify?token=${encodeURIComponent(token)}`)
      .then((r) => {
        localStorage.setItem("pf_guest_token", r.data.access_token);
        navigate("/guide");
      })
      .catch(() => setError("This link has expired or isn't valid — request a fresh one. Links stay valid for a year."));
  }, [params, navigate]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4">
      <div className="text-center" data-testid="verify-page">
        <div className="flex justify-center mb-5"><PebbleMark size={52} /></div>
        {error ? (
          <div data-testid="verify-error">
            <h1 className="font-serif text-2xl font-semibold text-charcoal">That link didn't work</h1>
            <p className="text-soft mt-2 max-w-sm mx-auto">{error}</p>
            <Link to="/login" className="inline-block mt-6 bg-copper text-cream font-bold rounded-full px-7 py-3.5 hover:bg-copperdeep transition-colors" data-testid="verify-relogin-button">
              Request a new link
            </Link>
          </div>
        ) : (
          <div className="animate-pulse" data-testid="verify-loading">
            <p className="font-serif italic text-soft text-lg">Opening your welcome guide…</p>
          </div>
        )}
      </div>
    </div>
  );
}
